import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrecheckExternalComponent } from './precheck-external.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PrecheckTestComponent } from './precheck-test-screen/precheck-test.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../../sharedModule/shared.module';

@NgModule({
  declarations: [
    PrecheckExternalComponent,
    PrecheckTestComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    NgxSpinnerModule,
    MatTooltipModule,
    SharedModule
  ],
  exports: [
    PrecheckExternalComponent,
    PrecheckTestComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PrecheckExternalModule { }
